import AllCatIcon from '../../../svg/categories/allCatIcon';
import AutoIcon from '../../../svg/categories/autoIcon';
import BooksIcon from '../../../svg/categories/booksIcon';
import CollectionIcon from '../../../svg/categories/collectionIcon';
import BricoIcon from '../../../svg/categories/bricoIcon';
import HifiIcon from '../../../svg/categories/hifiIcon';
import ComputerIcon from '../../../svg/categories/infoIcon';
import MaisonIcon from '../../../svg/categories/maisonIcon';
import ModeIcon from '../../../svg/categories/modeIcon';
import MoviesIcon from '../../../svg/categories/moviesIcon';
import SbpIcon from '../../../svg/categories/sbpIcon';
import TelIcon from '../../../svg/categories/telIcon';
import EnfantIcon from '../../../svg/categories/toysIcon';
import VideoGamesIcon from '../../../svg/categories/videogamesIcon';
import MusicIcon from '../../../svg/categories/musicIcon';
import SportIcon from '../../../svg/categories/sportIcon';
import ServicesIcon from '../../../svg/categories/priceServicesIcon';
import CardIcon from '../../../svg/nav/cardIcon';
import RakutenLogo from '../../../svg/rakuten';
import SellIcon from '../../../svg/nav/sellIcon';
import HelpIcon from '../../../svg/nav/helpIcon';
import CartIcon from '../../../svg/nav/cartIcon';
import CreditCard from '../../../svg/nav/creditCard';
import PinIcon from '../../../svg/nav/pinIcon';
import HeartIcon from '../../../svg/nav/heartIcon';
import ProfileIcon from '../../../svg/nav/profileIcon';
import Facebook from '../../../svg/social/facebook';
import Youtube from '../../../svg/social/youtube';
import Instagram from '../../../svg/social/instagram';
import Pinterest from '../../../svg/social/pinterest';
import Twitter from '../../../svg/social/twitter';
import Linkedin from '../../../svg/social/linkedin';
import MasterCard from '../../../svg/paymentMethods/mastercard';
import Visa from '../../../svg/paymentMethods/visa';
import Cofidis from '../../../svg/paymentMethods/cofidis';
import Paypal from '../../../svg/paymentMethods/paypal';
import PlayStore from '../../../svg/apps/playStore';
import AppStore from '../../../svg/apps/appStore';
import BagIcon from '../../../svg/nav/bagIcon';
import ShieldIcon from '../../../svg/nav/shieldIcon';
import CustomerCareIcon from '../../../svg/nav/customercareIcon';
import StarIcon from '../../../svg/nav/starIcon';
import InfoIcon from '../../../svg/nav/infoIcon';
import WorldIcon from '../../../svg/nav/worldIcon';
import OrderTracking from '../../../svg/nav/orderTrackingIcon';
import Desktop from '../../../svg/nav/desktopIcon';
import Logout from '../../../svg/nav/logoutIcon';

const FILL_ACTIVE = '#FFFFFF';
const FILL_INACTIVE = '#828282';
const SBP_RED = '#E74545';
const RAKUTEN_RED = '#BF0000';

function defaultIcon(icon) {
  return {
    icon,
  };
}

const can3Mapping = new Map();
// categories mapping
can3Mapping.set('allcat', defaultIcon(AllCatIcon));
can3Mapping.set('auto', defaultIcon(AutoIcon));
can3Mapping.set('books', defaultIcon(BooksIcon));
can3Mapping.set('livres', defaultIcon(BooksIcon));
can3Mapping.set('collection', defaultIcon(CollectionIcon));
can3Mapping.set('computer', defaultIcon(ComputerIcon));
can3Mapping.set('hifi', defaultIcon(HifiIcon));
can3Mapping.set('maison', defaultIcon(MaisonIcon));
can3Mapping.set('mode', defaultIcon(ModeIcon));
can3Mapping.set('movies', defaultIcon(MoviesIcon));
can3Mapping.set('video', defaultIcon(MoviesIcon));
can3Mapping.set('sport', defaultIcon(SportIcon));
can3Mapping.set('enfant', defaultIcon(EnfantIcon));
can3Mapping.set('jv', defaultIcon(VideoGamesIcon));
can3Mapping.set('music', defaultIcon(MusicIcon));
can3Mapping.set('musique', defaultIcon(MusicIcon));
can3Mapping.set('brico', defaultIcon(BricoIcon));
can3Mapping.set('jardin', defaultIcon(BricoIcon));
can3Mapping.set('tel', defaultIcon(TelIcon));
can3Mapping.set('services', defaultIcon(ServicesIcon));
can3Mapping.set('priceclub', defaultIcon(CardIcon));
can3Mapping.set('sbp', { icon: SbpIcon, fillInactive: SBP_RED, fillActive: SBP_RED });
// logo
can3Mapping.set('rakuten', defaultIcon(RakutenLogo));
// nav button mapping TODO : use nav.xx to map this one
can3Mapping.set('sell', defaultIcon(SellIcon));
can3Mapping.set('help', defaultIcon(HelpIcon));
can3Mapping.set('pin', defaultIcon(PinIcon));
can3Mapping.set('heart', defaultIcon(HeartIcon));
can3Mapping.set('profile', defaultIcon(ProfileIcon));
can3Mapping.set('cart', defaultIcon(CartIcon));
can3Mapping.set('creditCard', defaultIcon(CreditCard));
can3Mapping.set('orderTracking', defaultIcon(OrderTracking));
can3Mapping.set('desktop', defaultIcon(Desktop));
can3Mapping.set('logout', defaultIcon(Logout));
// social links mapping TODO : use social.xx to map this one
can3Mapping.set('facebook', defaultIcon(Facebook));
can3Mapping.set('youtube', defaultIcon(Youtube));
can3Mapping.set('instagram', defaultIcon(Instagram));
can3Mapping.set('pinterest', defaultIcon(Pinterest));
can3Mapping.set('twitter', defaultIcon(Twitter));
can3Mapping.set('linkedin', defaultIcon(Linkedin));
can3Mapping.set('mastercard', defaultIcon(MasterCard));
can3Mapping.set('visa', defaultIcon(Visa));
can3Mapping.set('cofidis', defaultIcon(Cofidis));
can3Mapping.set('paypal', defaultIcon(Paypal));
// app links mapping TODO : use app.xx to map this one
can3Mapping.set('playstore', defaultIcon(PlayStore));
can3Mapping.set('appstore', defaultIcon(AppStore));
// reinsurance
can3Mapping.set('bag', defaultIcon(BagIcon));
can3Mapping.set('shield', defaultIcon(ShieldIcon));
can3Mapping.set('customercare', defaultIcon(CustomerCareIcon));
// eslint-disable-next-line max-len
can3Mapping.set('cardPriceclub_light', { icon: CardIcon, fillInactive: RAKUTEN_RED, fillActive: RAKUTEN_RED, width: '85px', height: '40px' });
can3Mapping.set('cardPriceclub', { icon: CardIcon, fillInactive: RAKUTEN_RED, fillActive: RAKUTEN_RED });
// corporate
can3Mapping.set('star', defaultIcon(StarIcon));
can3Mapping.set('info', defaultIcon(InfoIcon));
can3Mapping.set('world', defaultIcon(WorldIcon));

function svgMapper(uri, color = {}) {
  // trunk last part of the uri for get the literal name (useful for category mainly)
  const icons = /^.+\/(.+)\..+$/.exec(uri);

  // Return null if no match ( == simple icon)
  const checkInMap = icons ? icons[1] : uri;
  const elt = can3Mapping.get(checkInMap);
  if (elt === undefined) {
    /* Whatever it is, it just have to be a string. */
    return 'url';
  }

  elt.widthIcon = elt.width || undefined;
  elt.heightIcon = elt.height || undefined;

  elt.fillInactive = elt.fillInactive || color.inactive || FILL_INACTIVE;
  elt.fillActive = elt.fillActive || color.active || FILL_ACTIVE;
  return elt;
}
export default svgMapper;
